import { Controller } from "@hotwired/stimulus"

// SEM: the waiting experience for an advisory assessment's pending frame (#275). While the judge
// computes, it shows a live elapsed timer + an expectation, so an inherently long (~1-2 min) call
// reads as "still working," not a hang. Anchored to when the row entered pending/in_progress
// (started-at = the assessment's updated_at), so a cold page load shows the TRUE elapsed, not zero.
// Once elapsed crosses the (advisory) recover-after threshold it reveals the recovery prompt —
// "reload to check; only re-run if it's still blank" — and drops the expectation. It NEVER freezes
// the timer or claims the job failed: it only offers a way out (a lost live push, or a worker that
// died mid-run, both leave this frame stuck). Owns display only, no server truth. When the terminal
// verdict is broadcast, Turbo replaces this whole frame and the controller disconnects.
export default class extends Controller {
  static values = { startedAt: String, recoverAfter: Number }
  static targets = ["elapsed", "expectation", "recovery"]

  connect() {
    this.tick()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  tick() {
    const started = Date.parse(this.startedAtValue)
    if (Number.isNaN(started)) return
    const seconds = Math.max(0, Math.floor((Date.now() - started) / 1000))

    if (this.hasElapsedTarget) {
      const minutes = Math.floor(seconds / 60)
      const rest = String(seconds % 60).padStart(2, "0")
      this.elapsedTarget.textContent = `${minutes}:${rest}`
    }

    if (this.recoverAfterValue > 0 && seconds >= this.recoverAfterValue) this.reveal()
  }

  // Advisory: surface the recovery prompt, keep the timer running. Idempotent — safe to call every tick.
  reveal() {
    if (this.hasExpectationTarget) this.expectationTarget.hidden = true
    if (this.hasRecoveryTarget) this.recoveryTarget.hidden = false
  }
}
